const translations = {
    'config.error.buildings.required': 'buildings config is required',
    'config.error.buildings.entry': 'buildings.%s must be defined',
    'config.error.buildings.cost.object': 'buildings.%s.cost must be an object',
    'config.error.buildings.cost.value': 'buildings.%s.cost has invalid value for %s',
    'config.error.buildings.costScaling.required': 'buildings.%s.costScaling must be defined',
    'config.error.buildings.costScaling.a': 'buildings.%s.costScaling.a must be >= 0',
    'config.error.buildings.costScaling.b': 'buildings.%s.costScaling.b must be >= 0',
    'config.error.buildings.storage.max': 'buildings.%s.%s.%s.max must be >= 0',
    'config.error.cost.object': '%s cost must be an object',
    'config.error.cost.value': '%s cost has invalid value for %s',
    'config.error.costScaling.a': 'costScaling.%s.a must be >= 0',
    'config.error.costScaling.b': 'costScaling.%s.b must be >= 0',
    'config.error.costScaling.entry': 'costScaling.%s must be defined',
    'config.error.costScaling.required': 'costScaling config is required',
    'config.error.construction.required': 'construction config is required',
    'config.error.construction.refund.required': 'construction.refund is required',
    'config.error.construction.refund.percent': 'construction.refund.percent must be 0-100',
    'config.error.construction.refund.allowInProgress':
        'construction.refund.allowInProgress must be a boolean',
    'config.error.defaults.populationPerHouse': 'defaults.populationPerHouse must be > 0',
    'config.error.defaults.houseFoodTargetHours': 'defaults.houseFoodTargetHours must be > 0',
    'config.error.defaults.houseHeatTargetHours': 'defaults.houseHeatTargetHours must be > 0',
    'config.error.defaults.sawmillInputCap': 'defaults.sawmillInputCap must be >= 0',
    'config.error.defaults.sawmillOutputCap': 'defaults.sawmillOutputCap must be >= 0',
    'config.error.defaults.charcoalInputCap': 'defaults.charcoalInputCap must be >= 0',
    'config.error.defaults.charcoalOutputCap': 'defaults.charcoalOutputCap must be >= 0',
    'config.error.defaults.blacksmithInputCap': 'defaults.blacksmithInputCap must be >= 0',
    'config.error.defaults.blacksmithOutputCap': 'defaults.blacksmithOutputCap must be >= 0',
    'config.error.fish.regenRate': 'fish.regenRate must be >= 0',
    'config.error.fish.required': 'fish config is required',
    'config.error.heat.required': 'heat config is required',
    'config.error.heat.coldInterval': 'heat.coldInterval must be > 0',
    'config.error.heat.coldStep.required': 'heat.coldStep is required',
    'config.error.heat.coldStep.wooden': 'heat.coldStep.wooden must be >= 0',
    'config.error.heat.coldStep.stone': 'heat.coldStep.stone must be >= 0',
    'config.error.heat.warmInterval': 'heat.warmInterval must be > 0',
    'config.error.heat.maxWarmth.required': 'heat.maxWarmth is required',
    'config.error.heat.maxWarmth.wooden': 'heat.maxWarmth.wooden must be > 0',
    'config.error.heat.maxWarmth.stone': 'heat.maxWarmth.stone must be > 0',
    'config.error.heat.warmth.required': 'heat.warmth is required',
    'config.error.heat.warmth.wood': 'heat.warmth.wood must be > 0',
    'config.error.heat.warmth.charcoal': 'heat.warmth.charcoal must be > 0',
    'config.error.initial.inventory': 'initial.inventory must be provided',
    'config.error.initial.inventory.bricks': 'initial.inventory.bricks must be >= 0',
    'config.error.initial.inventory.charcoal': 'initial.inventory.charcoal must be >= 0',
    'config.error.initial.inventory.clothRope': 'initial.inventory.clothRope must be >= 0',
    'config.error.initial.inventory.coins': 'initial.inventory.coins must be >= 0',
    'config.error.initial.inventory.fiber': 'initial.inventory.fiber must be >= 0',
    'config.error.initial.inventory.fish': 'initial.inventory.fish must be >= 0',
    'config.error.initial.inventory.food': 'initial.inventory.food must be >= 0',
    'config.error.initial.inventory.goldOre': 'initial.inventory.goldOre must be >= 0',
    'config.error.initial.inventory.ironIngots': 'initial.inventory.ironIngots must be >= 0',
    'config.error.initial.inventory.ironOre': 'initial.inventory.ironOre must be >= 0',
    'config.error.initial.inventory.leather': 'initial.inventory.leather must be >= 0',
    'config.error.initial.inventory.planks': 'initial.inventory.planks must be >= 0',
    'config.error.initial.inventory.stone': 'initial.inventory.stone must be >= 0',
    'config.error.initial.inventory.tools': 'initial.inventory.tools must be >= 0',
    'config.error.initial.inventory.weapons': 'initial.inventory.weapons must be >= 0',
    'config.error.initial.inventory.wood': 'initial.inventory.wood must be >= 0',
    'config.error.initial.required': 'initial must be provided',
    'config.error.initial.settlement': 'initial.settlement must be provided',
    'config.error.initial.settlement.buildings': 'initial.settlement.buildings must be provided',
    'config.error.initial.settlement.buildings.blacksmith.qty':
        'initial.settlement.buildings.blacksmith.qty must be >= 0',
    'config.error.initial.settlement.buildings.charcoalPit.qty':
        'initial.settlement.buildings.charcoalPit.qty must be >= 0',
    'config.error.initial.settlement.buildings.farm.qty':
        'initial.settlement.buildings.farm.qty must be >= 0',
    'config.error.initial.settlement.buildings.fishingHut.qty':
        'initial.settlement.buildings.fishingHut.qty must be >= 0',
    'config.error.initial.settlement.buildings.goldMine.qty':
        'initial.settlement.buildings.goldMine.qty must be >= 0',
    'config.error.initial.settlement.buildings.houses':
        'initial.settlement.buildings.houses must be >= 0',
    'config.error.initial.settlement.buildings.stoneHouse':
        'initial.settlement.buildings.stoneHouse must be >= 0',
    'config.error.initial.settlement.buildings.huntingHut.qty':
        'initial.settlement.buildings.huntingHut.qty must be >= 0',
    'config.error.initial.settlement.buildings.ironMine.qty':
        'initial.settlement.buildings.ironMine.qty must be >= 0',
    'config.error.initial.settlement.buildings.lumberjack.qty':
        'initial.settlement.buildings.lumberjack.qty must be >= 0',
    'config.error.initial.settlement.buildings.masonry.qty':
        'initial.settlement.buildings.masonry.qty must be >= 0',
    'config.error.initial.settlement.buildings.mint.qty':
        'initial.settlement.buildings.mint.qty must be >= 0',
    'config.error.initial.settlement.buildings.caravanPost.qty':
        'initial.settlement.buildings.caravanPost.qty must be >= 0',
    'config.error.initial.settlement.buildings.stable.qty':
        'initial.settlement.buildings.stable.qty must be >= 0',
    'config.error.initial.settlement.buildings.quarry.qty':
        'initial.settlement.buildings.quarry.qty must be >= 0',
    'config.error.initial.settlement.buildings.sawmill.qty':
        'initial.settlement.buildings.sawmill.qty must be >= 0',
    'config.error.initial.settlement.buildings.smelter.qty':
        'initial.settlement.buildings.smelter.qty must be >= 0',
    'config.error.initial.settlement.buildings.smokehouse.qty':
        'initial.settlement.buildings.smokehouse.qty must be >= 0',
    'config.error.initial.settlement.buildings.weaver.qty':
        'initial.settlement.buildings.weaver.qty must be >= 0',
    'config.error.initial.settlement.population': 'initial.settlement.population must be > 0',
    'config.error.initial.settlement.tier':
        'initial.settlement.tier must be outpost, town, or city',
    'config.error.map.required': 'map must be provided',
    'config.error.map.size': 'map.size must be "small", "medium", or "huge"',
    'config.error.map.seed': 'map.seed must be a number',
    'config.error.population.required': 'population config is required',
    'config.error.population.hunger.required': 'population.hunger is required',
    'config.error.population.hunger.hungerInterval': 'population.hunger.hungerInterval must be > 0',
    'config.error.population.hunger.hungerStep': 'population.hunger.hungerStep must be > 0',
    'config.error.population.hunger.maxHunger': 'population.hunger.maxHunger must be > 0',
    'config.error.population.hunger.eatThreshold': 'population.hunger.eatThreshold must be > 0',
    'config.error.population.hunger.foodStep': 'population.hunger.foodStep must be > 0',
    'config.error.population.hunger.foodQty': 'population.hunger.foodQty must be > 0',
    'config.error.population.warmth.required': 'population.warmth is required',
    'config.error.population.warmth.maxWarmth': 'population.warmth.maxWarmth must be > 0',
    'config.error.population.warmth.coldInterval': 'population.warmth.coldInterval must be > 0',
    'config.error.population.warmth.coldStep': 'population.warmth.coldStep must be > 0',
    'config.error.population.warmth.warmthStep': 'population.warmth.warmthStep must be > 0',
    'config.error.population.warmth.coldDebtThreshold':
        'population.warmth.coldDebtThreshold must be >= 0',
    'config.error.production.blacksmith': 'production.blacksmith is required',
    'config.error.production.blacksmith.toolIngots': 'production.blacksmith.toolIngots must be > 0',
    'config.error.production.blacksmith.toolTicks': 'production.blacksmith.toolTicks must be > 0',
    'config.error.production.blacksmith.toolWood': 'production.blacksmith.toolWood must be > 0',
    'config.error.production.blacksmith.toolsPerBatch':
        'production.blacksmith.toolsPerBatch must be > 0',
    'config.error.production.blacksmith.weaponIngots':
        'production.blacksmith.weaponIngots must be > 0',
    'config.error.production.blacksmith.weaponLeather':
        'production.blacksmith.weaponLeather must be > 0',
    'config.error.production.blacksmith.weaponTicks':
        'production.blacksmith.weaponTicks must be > 0',
    'config.error.production.blacksmith.weaponWood': 'production.blacksmith.weaponWood must be > 0',
    'config.error.production.blacksmith.weaponsPerBatch':
        'production.blacksmith.weaponsPerBatch must be > 0',
    'config.error.production.builderWorkPerTick': 'production.builderWorkPerTick must be > 0',
    'config.error.production.charcoal': 'production.charcoal config is required',
    'config.error.production.charcoal.ticksPerBatch':
        'production.charcoal.ticksPerBatch must be > 0',
    'config.error.production.farm': 'production.farm is required',
    'config.error.production.farm.ticksPerFarmer': 'production.farm.ticksPerFarmer must be > 0',
    'config.error.production.farm.toolUsage': 'production.farm.toolUsage must be > 0',
    'config.error.production.fishing': 'production.fishing is required',
    'config.error.production.fishing.fishPerCatch': 'production.fishing.fishPerCatch must be > 0',
    'config.error.production.fishing.ticksPerCatch': 'production.fishing.ticksPerCatch must be > 0',
    'config.error.production.forester': 'production.forester is required',
    'config.error.production.forester.ticksPerTree': 'production.forester.ticksPerTree must be > 0',
    'config.error.production.goldMine': 'production.goldMine is required',
    'config.error.production.goldMine.ticksPerOre': 'production.goldMine.ticksPerOre must be > 0',
    'config.error.production.hunter': 'production.hunter is required',
    'config.error.production.hunter.foodPerWildLife':
        'production.hunter.foodPerWildLife must be > 0',
    'config.error.production.hunter.leatherPerWildLife':
        'production.hunter.leatherPerWildLife must be >= 0',
    'config.error.production.hunter.minHuntTicks': 'production.hunter.minHuntTicks must be > 0',
    'config.error.production.hunter.ticksPerHuntRatio':
        'production.hunter.ticksPerHuntRatio is required',
    'config.error.production.hunter.ticksPerHuntRatio.ticks':
        'production.hunter.ticksPerHuntRatio.ticks must be > 0',
    'config.error.production.hunter.ticksPerHuntRatio.wildLife':
        'production.hunter.ticksPerHuntRatio.wildLife must be > 0',
    'config.error.production.hunter.toolUsage': 'production.hunter.toolUsage must be > 0',
    'config.error.production.ironMine': 'production.ironMine config is required',
    'config.error.production.ironMine.ticksPerOre': 'production.ironMine.ticksPerOre must be > 0',
    'config.error.production.lumberWorkPerWood': 'production.lumberWorkPerWood must be > 0',
    'config.error.production.masonry': 'production.masonry config is required',
    'config.error.production.masonry.ticksPerBrick': 'production.masonry.ticksPerBrick must be > 0',
    'config.error.production.mint': 'production.mint is required',
    'config.error.production.mint.ticksPerBatch': 'production.mint.ticksPerBatch must be > 0',
    'config.error.production.populationGrowthPerTick':
        'production.populationGrowthPerTick must be >= 0',
    'config.error.production.quarry': 'production.quarry config is required',
    'config.error.production.quarry.ticksPerStone': 'production.quarry.ticksPerStone must be > 0',
    'config.error.production.sawmillWorkPerBatch': 'production.sawmillWorkPerBatch must be > 0',
    'config.error.production.smelter': 'production.smelter config is required',
    'config.error.production.smelter.charcoalPerBatch':
        'production.smelter.charcoalPerBatch must be > 0',
    'config.error.production.smelter.ingotsPerBatch':
        'production.smelter.ingotsPerBatch must be > 0',
    'config.error.production.smelter.orePerBatch': 'production.smelter.orePerBatch must be > 0',
    'config.error.production.smelter.ticksPerBatch': 'production.smelter.ticksPerBatch must be > 0',
    'config.error.production.smokehouse': 'production.smokehouse is required',
    'config.error.production.smokehouse.fishPerBatch':
        'production.smokehouse.fishPerBatch must be > 0',
    'config.error.production.smokehouse.foodPerBatch':
        'production.smokehouse.foodPerBatch must be > 0',
    'config.error.production.smokehouse.ticksPerBatch':
        'production.smokehouse.ticksPerBatch must be > 0',
    'config.error.production.weaver': 'production.weaver is required',
    'config.error.production.weaver.ticksPerBatch': 'production.weaver.ticksPerBatch must be > 0',
    'config.error.time.campaignDays': 'time.campaignDays must be > 0',
    'config.error.time.campaignTicks': 'time.campaignTicks must be > 0',
    'config.error.audio.required': 'audio must be defined',
    'config.error.audio.entry': 'audio.%s must be defined',
    'config.error.audio.enabled': 'audio.%s.enabled must be a boolean',
    'config.error.audio.volume': 'audio.%s.volume must be between 0 and 1',
    'config.error.time.required': 'time must be provided',
    'config.error.time.tickSeconds': 'time.tickSeconds must be > 0',
    'config.error.time.ticksPerDay': 'time.ticksPerDay must be > 0',
    'config.error.time.ticksPerHour': 'time.ticksPerHour must be > 0',
    'config.error.time.ticksPerMinute': 'time.ticksPerMinute must be > 0',
    'config.error.expedition.baseTicks': 'expedition.baseTicks must be > 0',
    'config.error.expedition.banditLossRange':
        'expedition.encounters.banditLossRange must be [min,max]',
    'config.error.expedition.encounters': 'expedition.encounters is required',
    'config.error.expedition.fatalFactions': 'expedition.encounters.fatalFactions must be a list',
    'config.error.expedition.foodPerPopPerHex': 'expedition.foodPerPopPerHex must be >= 0',
    'config.error.expedition.required': 'expedition is required',
    'config.error.expedition.stealAll': 'expedition.encounters.stealAll must be boolean',
    'config.error.expedition.ticksPerHex': 'expedition.ticksPerHex must be > 0',
    'config.error.expedition.toolsRequired': 'expedition.toolsRequired must be >= 0',
    'config.error.alerts.required': 'alerts config is required',
    'config.error.alerts.warningCooldownTicks': 'alerts.warningCooldownTicks must be >= 0',
    'config.error.alerts.starvationHours': 'alerts.starvationHours must be >= 0',
    'config.error.alerts.coldDebtRatio': 'alerts.coldDebtRatio must be >= 0',
    'config.error.transport.baseTicks': 'transport.baseTicks must be > 0',
    'config.error.transport.departureInterval': 'transport.departureInterval must be > 0',
    'config.error.transport.required': 'transport is required',
    'config.error.transport.ticksPerHex': 'transport.ticksPerHex must be > 0',
    'config.error.tool.initialDurability': 'tool.initialDurability must be > 0',
    'config.error.tool.required': 'tool config is required',
    'config.error.tree.ageInterval': 'tree.ageInterval must be > 0',
    'config.error.tree.cutWorkBase': 'tree.cutWorkBase must be > 0',
    'config.error.tree.cutWorkPerAge': 'tree.cutWorkPerAge must be >= 0',
    'config.error.tree.maxAge': 'tree.maxAge must be > 0',
    'config.error.tree.peakAge': 'tree.peakAge must be between 0 and maxAge',
    'config.error.tree.required': 'tree config is required',
    'config.error.tree.reseedInterval': 'tree.reseedInterval must be > 0',
    'config.error.tree.reseedRate': 'tree.reseedRate must be >= 0',
    'config.error.tree.reseedThreshold': 'tree.reseedThreshold must be between 0 and 1',
    'config.error.tree.yieldAgeFactor': 'tree.yieldAgeFactor must be >= 0',
    'config.error.tree.yieldBase': 'tree.yieldBase must be > 0',
    'config.error.tree.yieldMinMultiplier': 'tree.yieldMinMultiplier must be between 0 and 1',
    'config.error.tree.yieldTailMultiplier': 'tree.yieldTailMultiplier must be between 0 and 1',
    'config.error.ui.language': 'ui.language must be "en" or "pl"',
    'config.error.ui.storageStatsMinutes': 'ui.storageStatsMinutes must be a positive number',
    'config.error.ui.required': 'ui must be provided',
    'config.error.wildLife.ageTicks': 'wildLife.ageTicks must be > 0',
    'config.error.wildLife.baseMortalityPerAgeTick':
        'wildLife.baseMortalityPerAgeTick must be between 0 and 1',
    'config.error.wildLife.biomeCapWeight': 'wildLife.biomeCapWeight must be between 0 and 1',
    'config.error.wildLife.colonizeEmptyChance':
        'wildLife.colonizeEmptyChance must be between 0 and 1',
    'config.error.wildLife.colonizeEmptyMax':
        'wildLife.colonizeEmptyMax must be >= colonizeEmptyMin',
    'config.error.wildLife.colonizeEmptyMin': 'wildLife.colonizeEmptyMin must be >= 0',
    'config.error.wildLife.fecundityPerAdult': 'wildLife.fecundityPerAdult must be >= 0',
    'config.error.wildLife.huntableAgeMin': 'wildLife.huntableAgeMin must be >= 0',
    'config.error.wildLife.juvenileAgeEnd': 'wildLife.juvenileAgeEnd must be >= 0',
    'config.error.wildLife.juvenileExtraMortality':
        'wildLife.juvenileExtraMortality must be between 0 and 1',
    'config.error.wildLife.matingAgeStart': 'wildLife.matingAgeStart must be >= 0',
    'config.error.wildLife.matingInterval': 'wildLife.matingInterval must be > 0',
    'config.error.wildLife.maxAge': 'wildLife.maxAge must be > 0',
    'config.error.wildLife.migrationInterval': 'wildLife.migrationInterval must be > 0',
    'config.error.wildLife.migrationRadius': 'wildLife.migrationRadius must be >= 1',
    'config.error.wildLife.migrationRate': 'wildLife.migrationRate must be > 0',
    'config.error.wildLife.newbornAge': 'wildLife.newbornAge must be >= 0',
    'config.error.wildLife.overCapacityCullRate':
        'wildLife.overCapacityCullRate must be between 0 and 1',
    'config.error.wildLife.reproductionDensityPower':
        'wildLife.reproductionDensityPower must be > 0',
    'config.error.wildLife.required': 'wildLife config is required',
    'config.error.wildLife.senescentAgeStart': 'wildLife.senescentAgeStart must be >= 0',
    'config.error.wildLife.senescentMortalitySlope':
        'wildLife.senescentMortalitySlope must be >= 0',
    'config.error.wildLife.targetFill': 'wildLife.targetFill must be between 0 and 1',
    'config.error.wildLife.treesPerAnimal': 'wildLife.treesPerAnimal must be > 0',
    'config.error.initial.settlement.buildings.barracks.qty':
        'initial.settlement.buildings.barracks.qty must be >= 0',
    'config.error.scouting.required': 'scouting config is required',
    'config.error.scouting.baseTicks': 'scouting.baseTicks must be >= 0',
    'config.error.scouting.ticksPerHex': 'scouting.ticksPerHex must be >= 0',
    'config.error.scouting.foodMultiplier': 'scouting.foodMultiplier must be > 0',
    'config.error.scouting.foodStep': 'scouting.foodStep must be > 0',
    'config.error.battle.required': 'battle config is required',
    'config.error.battle.roundTicks': 'battle.roundTicks must be > 0',
    'config.error.battle.unitsPerRound': 'battle.unitsPerRound must be > 0',
    'config.error.battle.minRounds': 'battle.minRounds must be > 0',
    'config.error.battle.maxRounds': 'battle.maxRounds must be >= minRounds',
    'config.error.battle.rollRange': 'battle.rollMin/rollMax must be valid',
    'config.error.battle.encounterChance': 'battle.encounterChance must be >= 0',
    'config.error.battle.encounterScaling': 'battle.encounterScaling is required',
    'config.error.battle.encounterScaling.countJitter':
        'battle.encounterScaling.countJitter must be >= 0',
    'config.error.battle.encounterScaling.maxChance':
        'battle.encounterScaling.maxChance must be >= minChance',
    'config.error.battle.encounterScaling.maxCountMultiplier':
        'battle.encounterScaling.maxCountMultiplier must be >= minCountMultiplier',
    'config.error.battle.encounterScaling.maxDistance':
        'battle.encounterScaling.maxDistance must be > 0',
    'config.error.battle.encounterScaling.minChance':
        'battle.encounterScaling.minChance must be >= 0',
    'config.error.battle.encounterScaling.minCountMultiplier':
        'battle.encounterScaling.minCountMultiplier must be > 0',
    'config.error.battle.units': 'battle.units must be defined',
    'config.error.battle.enemies': 'battle.enemies must be defined',
    'config.error.battle.unit.id': 'battle unit %s must have id',
    'config.error.battle.unit.labelKey': 'battle unit %s must have labelKey',
    'config.error.battle.unit.power': 'battle unit %s power must be >= 0',
    'config.error.battle.unit.foodPerHex': 'battle unit %s foodPerHex must be >= 0',
    'config.error.battle.unit.weaponCost': 'battle unit %s weaponCost must be >= 0',
    'config.error.battle.enemy.weight': 'battle enemy %s weight must be >= 0',
    'config.error.battle.enemy.countRange': 'battle enemy %s countRange must be [min, max]',
};

export default translations;
